//region 1. Platform Libraries
import bodyParser from 'body-parser';
import express from 'express';
import MongoClient from 'mongodb';
//endregion

//region 2. Project Libraries
import checkObjectID from '../middleware/checkObjectID';
import checkStreamIndex from '../middleware/checkStreamIndex';
//endregion

const context = {
        router: express.Router({ mergeParams: true }),
        cameras: null,
        logger: null,
};

context.router.use('/', checkObjectID);
context.router.use('/', checkStreamIndex);

context.router.get('/-1', (req, res) => {
        const log = (lvl, msg) => context.logger.log(lvl, msg, { tags: `GET ${req.originalUrl}` });
        const _id = new MongoClient.ObjectID(req.params.id);
        context.cameras.findOne(_id, (findOneCameraErr, camera) => {
                if (findOneCameraErr) {
                        log('error', findOneCameraErr.message);
                        res.status(500).send(findOneCameraErr.message);
                        return;
                }
                if (!camera) {
                        const message = 'Camera Not Found';
                        log('error', message);
                        res.status(500).send(message);
                        return;
                }
                /** @type Stream */
                const stream = camera.streams[req.params.index];
                if (!stream) {
                        const message = 'Stream Not Found';
                        log('error', message);
                        res.status(500).send(message);
                        return;
                }
                const videoInfo = stream.video_info;
                const reply = {};
                if (!videoInfo || videoInfo.length === 0) {
                        reply.index = 0;
                } else {
                        const lastVideoInfo = videoInfo[videoInfo.length - 1];
                        reply.index = lastVideoInfo.index;
                        reply.startTime = lastVideoInfo.start_time;
                        reply.endTime = lastVideoInfo.end_time;
                        reply.bucketName = lastVideoInfo.bucket_name;
                        reply.objectName = lastVideoInfo.object_name;
                }
                log('info', '200 OK');
                log('debug', JSON.stringify(reply, null, 2));
                res.status(200).send(reply);
        });
});

context.router.put('/', bodyParser.json());

context.router.put('/', (req, res) => {
        const log = (lvl, msg) => context.logger.log(lvl, msg, { tags: `PUT ${req.originalUrl}` });
        log('debug', JSON.stringify(req.body, null, 2));
        if (req.body.length === 0) {
                const message = 'No Request or Request Body';
                log('error', message);
                res.status(400).send(message);
                return;
        }
        const diff = {};
        diff[`streams.${req.params.index}.video_info`] = {
                index: req.body.index,
                start_time: req.body.startTime,
                end_time: req.body.endTime,
                bucket_name: req.body.bucketName,
                object_name: req.body.objectName,
        };
        const _id = new MongoClient.ObjectID(req.params.id);
        context.cameras.updateOne({ _id }, { $push: diff }, (err, result) => {
                if (err) {
                        log('error', err.message);
                        res.status(500).send(err.message);
                        return;
                }
                if (result.matchedCount === 0) {
                        const message = 'Camera Not Found';
                        log('error', message);
                        res.status(500).send(message);
                        return;
                }
                log('info', '200 OK');
                res.sendStatus(200);
        });
});

/**
 * @param {string} req.params.vindex
 */
context.router.put('/:vindex/status', (req, res) => {
        const log = (lvl, msg) => context.logger.log(lvl, msg, { tags: `PUT ${req.originalUrl}` });
        log('debug', JSON.stringify(req.body, null, 2));
        const index = parseInt(req.params.index, 10);
        const vindex = parseInt(req.params.vindex, 10);
        if (req.body.length === 0) {
                const message = 'No Request or Request Body';
                log('error', message);
                res.status(400).send(message);
                return;
        }
        const diff = {};
        diff[`streams.${index}.video_info.${vindex - 1}.status`] = req.body;
        const _id = MongoClient.ObjectID(req.params.id);
        context.cameras.updateOne({ _id }, { $set: diff }, (err, result) => {
                if (err) {
                        log('error', err.message);
                        res.status(500).send(err.message);
                        return;
                }
                if (result.matchedCount === 0) {
                        const message = 'Camera Not Found';
                        log('error', message);
                        res.status(500).send(message);
                        return;
                }
                log('info', '200 OK');
                res.sendStatus(200);
        });
});

//noinspection JSUnusedGlobalSymbols
/**
 * Mount router for /c/:/s/:/video-info
 * @param {object}         options          Options
 * @param {object}         options.app      Express App
 * @param {MongoClient.Db} options.database Associated Database
 * @param {winston.Logger} options.logger   Logger
 */
export default function mountVideoInfo(options) {
        context.logger = options.logger;
        const log = (lvl, msg) => context.logger.log(lvl, msg, { tags: 'mountVideoInfo' });
        log('debug', 'Mounting router for /c/:/s/:/video-info....');
        options.app.use('/cameras/:id/streams/:index/video-info', context.router);
        context.cameras = options.database.collection('cameras');
        log('info', 'Router for /c/:/s/:/video-info Mounted');
}
